import DesignButton from 'components/button/DesignButton';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';

const Login = () => {
  const auth = useAuth();

  if (auth.isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <div className="flex h-screen items-center justify-center bg-design-black">
      <div className="flex h-3/6 w-3/6 flex-col items-center">
        <img className="h-36" alt="login log" src="/sameday_logo.png" />
        <h4 className="mt-3 mb-4 uppercase text-white">Itinerary Viewer</h4>
        <div className="w-1/6">
          <DesignButton
            className="text-white"
            onClickHandler={async () => {
              await auth.signinRedirect();
            }}
          >
            Log in
          </DesignButton>
        </div>
      </div>
    </div>
  );
};

export default Login;
